// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".entity_infos_lawyer-module__link--28rCw{text-decoration:underline;cursor:pointer}\n", ""]);
// Exports
exports.locals = {
	"link": "entity_infos_lawyer-module__link--28rCw"
};
module.exports = exports;
